module.exports = __webpack_public_path__ + "static/06-d82a4edbcca9a09c103ed1b8161c0ee3.jpg";